interface XLineProps {
    direction: 'down' | 'up';
}

function XLine(props: XLineProps) {
    const { direction } = props;
    return <div className={`x-line x-line--${direction}`}></div>;
}

export default XLine;
